const mode = 'PROD';

export const API_BASE_URL =
    mode === 'DEV'
        ? 'http://localhost/melocalizae/src/php'
        : 'https://melocalizae.com.br/php';

// Helper para obter a data e hora atual no fuso horário de Brasília (GMT-3)
export const getBrasiliaDateString = () => {
    try {
        const d = new Date();
        const parts = new Intl.DateTimeFormat('pt-BR', {
            timeZone: 'America/Sao_Paulo',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        }).formatToParts(d);
        const map = {};
        parts.forEach(p => map[p.type] = p.value);
        return `${map.year}-${map.month}-${map.day} ${map.hour}:${map.minute}:${map.second}`;
    } catch (e) {
        return new Date().toISOString();
    }
};

// Helper resiliente para obter ou gerar o session_id único
export const getSessionId = () => {
    let sid = localStorage.getItem('session_id');
    if (!sid) {
        sid = typeof crypto !== 'undefined' && crypto.randomUUID
            ? crypto.randomUUID()
            : 'sess_' + Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
        localStorage.setItem('session_id', sid);
    }
    return sid;
};

/* LOGS DE EVENTOS E NAVEGAÇÃO */
export const registrarLog = async (pagina, acao, consulta_relatorio = null) => {
    try {
        const sid = getSessionId();

        const payload = {
            tipo: 'evento',
            pagina: pagina,
            acao: acao,
            data_hora: getBrasiliaDateString(),
            session_id: sid,
            consulta_relatorio: consulta_relatorio
        };

        const response = await fetch(`${API_BASE_URL}/events/events-register.php`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        }
    } catch (error) {
        console.warn('Erro ao registrar log:', error);
    }
};

/* LOGS DE TEMPO NA PÁGINA */
export const enviarTempo = (pagina, inicio, consulta_relatorio = null) => {
    try {
        const tempoMs = Date.now() - inicio;
        const tempoSegundos = Math.floor(tempoMs / 1000);
        const sid = getSessionId();

        if (tempoSegundos < 1) return;

        const payload = {
            tipo: 'tempo_permanencia',
            pagina: pagina,
            acao: tempoSegundos,
            tempo_segundos: tempoSegundos,
            data_hora: getBrasiliaDateString(),
            session_id: sid,
            consulta_relatorio: consulta_relatorio
        };

        const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });

        if (navigator.sendBeacon) {
            navigator.sendBeacon(`${API_BASE_URL}/events/events-register.php`, blob);
        } else {
            fetch(`${API_BASE_URL}/events/events-register.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
                keepalive: true
            }).catch(() => { });
        }
    } catch (error) {
        console.warn('Erro ao enviar tempo:', error);
    }
};
